module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "prect",
    attrs: {
      "id": "plates"
    }
  }, [_c('a', {
    attrs: {
      "id": "pVIII"
    }
  }), _vm._v("PLATES AND MAPS")]), _vm._v(" "), _c('p', {
    staticClass: "ahd"
  }, [_c('b', [_vm._v("Plates")])]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("All photographs are by the author unless otherwise stated.")]), _vm._v(" "), _c('p', {
    staticClass: "nl-t"
  }, [_c('a', {
    attrs: {
      "href": "#/plate_section.htm#plate1"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("1. ")]), _vm._v("Temple of Venus Genetrix, Rome.")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/plate_section.htm#plate2"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("2. ")]), _vm._v("Tomb of Caecilia Metella, Via Appia, Rome.")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/plate_section.htm#plate3"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("3. ")]), _vm._v("Cleopatra VII and Caesarion, Dendara, Egypt.")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/plate_section.htm#plate4"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("4. ")]), _vm._v("Pompeii lovers, British Museum, London.")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/plate_section.htm#plate5"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("5. ")]), _vm._v("Theatre of Marcellus, Rome.")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/plate_section.htm#plate6"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("6. ")]), _vm._v("Porticus of Octavia, Rome.")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/plate_section.htm#plate7"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("7. ")]), _vm._v("Ara Pacis, Museo dell’Ara Pacis, Rome.")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/plate_section.htm#plate8"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("8. ")]), _vm._v("Agrippa and Julia, Ara Pacis, Museo dell’Ara Pacis, Rome.")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/plate_section.htm#plate9"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("9. ")]), _vm._v("Bust of Livia, British Museum, London.")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/plate_section.htm#plate10"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("10. ")]), _vm._v("Posthumous bust of Livia as the goddess Ceres, British Museum, London.")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/plate_section.htm#plate11"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("11. ")]), _vm._v("Clay oil lamp with a bust of Livia, British Museum, London.")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/plate_section.htm#plate12"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("12. ")]), _vm._v("Building of Eumachia, Pompeii.")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/plate_section.htm#plate13"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("13. ")]), _vm._v("The Mausoleum of Augustus, Rome.")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/plate_section.htm#plate14"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("14. ")]), _vm._v("Dedication to the Deified Augusta (Livia), Herculaneum, Museo Archeologico Nazionale, Naples.")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/plate_section.htm#plate15"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("15. ")]), _vm._v("Porticus of Livia, Marble Plan of Rome, Museo dei Fori Imperiali, Rome.")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "id": "pIX"
    }
  }), _c('a', {
    attrs: {
      "href": "#/plate_section.htm#plate16"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("16. ")]), _vm._v("Inscription of Lucius Caesar, Porticus of Gaius and Lucius, Rome.")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/plate_section.htm#plate17"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("17. ")]), _vm._v("Temple of Vesta, Roman Forum.")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/plate_section.htm#plate18"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("18. ")]), _vm._v("The Roman Forum.")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/plate_section.htm#plate19"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("19. ")]), _vm._v("Tombstone of Agrippina the Elder, Museo Capitolini, Rome.")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/plate_section.htm#plate20"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("20. ")]), _vm._v("Sestertius of Agrippina the Elder. Private collection.")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/plate_section.htm#plate21"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("21. ")]), _vm._v("Bronze coin of Messalina. Classical Numismatic Group, www.cngcoins.com.")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/plate_section.htm#plate22"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("22. ")]), _vm._v("Cistophoric tetradrachm of Claudius and Agrippina. Private collection.")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/plate_section.htm#plate23"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("23. ")]), _vm._v("The Gemma Claudia, Kunsthistorisches Museum Vienna. Photo and copyright: Gryffindor.")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/plate_section.htm#plate24"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("24. ")]), _vm._v("Agrippina crowns Nero, Aphrodisias, Turkey. Photo and copyright: Carole Raddato.")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/plate_section.htm#plate25"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("25. ")]), _vm._v("Nero’s Golden House, Rome.")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/plate_section.htm#plate26"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("26. ")]), _vm._v("Tetradrachm of Nero and Poppaea. Private collection.")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/plate_section.htm#plate27"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("27. ")]), _vm._v("View of Oplontis.")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/plate_section.htm#plate28"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("28. ")]), _vm._v("Sestertius of the Temple of the Deified Augustus and Livia. Private collection.")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/plate_section.htm#plate29"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("29. ")]), _vm._v("The Severan Women. Private collection.")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/plate_section.htm#plate30"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("30. ")]), _vm._v("Julia Domna and Septimius Severus on the Arch of the Moneychangers (Porta Argentarii), Rome.")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/plate_section.htm#plate31"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("31. ")]), _vm._v("Sestertius of Julia Mamaea. Private collection.")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/plate_section.htm#plate32"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("32. ")]), _vm._v("Julio-Claudian dynastic relief, Ravenna, Museo Nazionale di Ravenna. Photo and copyright: John Pollini.")])]), _vm._v(" "), _c('p', {
    staticClass: "ahd"
  }, [_c('b', [_vm._v("Maps")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/foreword.htm#map1"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("1. ")]), _vm._v("Rome, showing the main locations mentioned in the text.")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/foreword.htm#map2"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("2. ")]), _vm._v("Roman Italy, showing the main places mentioned in the text.")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/foreword.htm#map3"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("3. ")]), _vm._v("The Roman Empire, showing the main places mentioned in the text.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b703194c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/plates_and_maps.vue
// module id = 72
// module chunks = 0